import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import Checked from '../../images/checked 2.svg'
import {useNavigate} from 'react-router-dom'

const ConfirmModal= ({isOpen,setOpen}) => {
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate('/machine-interview')
    setOpen(false)
    }, 1000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const navigate=useNavigate()

  return (
    <>
  
      <Modal
        open={isOpen}
        onOk={handleOk}
        style={{padding:'100px 0'}}
        onCancel={handleCancel}
        centered
        footer={[
       
          <Button key="submit" type="primary" loading={loading} onClick={handleOk} style={{padding:'0 20px',marginRight:'200px',marginBottom:'40px' ,backgroundColor:'#1B49EA'}} >
           Okay!
          </Button>,
       
        ]}
      >
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>     <img src={ Checked} style={{width:'40px',height:'40px'}}/></div>
   
        <p style={{textAlign:'center',fontSize:'20px',fontWeight:600}}>Assesment Created</p>
        <p style={{textAlign:'center',padding:'0 30px'}} >The assessment is successfully created. 
You can invite more developers to attempt the assessment.</p>
      
      </Modal>
    </>
  );
};

export default ConfirmModal;